<template>
  <a-modal width="876px" :title="form.trip_id ? '修改行程信息' : '新增行程信息'" :visible="visible"
    :confirm-loading="confirmLoading" @ok="handleOk" @cancel="handleCancel" destroyOnClose :maskClosable="false">
    <a-form-model ref="ruleForm" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
      <a-row>
        <a-col :span="12">
          <a-form-model-item label="行程名称" prop="trip_name">
            <a-input v-model="form.trip_name" placeholder="请输入行程名称" />
          </a-form-model-item>
          <a-form-model-item label="人物关系" prop="trip_relationship">
            <a-input v-model="form.trip_relationship" placeholder="例如：几男几女、朋友、同事、同学、家人等" />
          </a-form-model-item>
          <a-form-model-item label="行程人数" prop="person_length">
            <a-input-number style="width: 100%" placeholder="请输入行程人数" v-model="form.person_length" :min="1"
              :precision="0" />
          </a-form-model-item>
          <a-form-model-item label="行程时间" prop="trip_days">
            <el-date-picker type="daterange" style="width: 100%;" v-model="times" placeholder="请选择" @change="changeDays"
              value-format="yyyy-MM-dd" :format="'yyyy-MM-dd'">
            </el-date-picker>
            <a-alert type="info" :message="'合计：' + timelength + '天'" banner />
          </a-form-model-item>
          <a-form-model-item label="提醒时间" prop="remind">
            <a-time-picker style="width: 100%;" v-model="form.remind" format="HH:mm:00" valueFormat="HH:mm:00" />
            <a-alert type="info" message="说明：设置的时间将在每天行程的前一天，通过钉钉群消息的方式提醒" banner />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="销售" prop="person_1">
            <a-select v-model="form.person_1" placeholder="请选择销售人员" :filter-option="filterOption" showSearch allowClear>
              <a-select-option v-for="v in userList" :key="v.user_id" :value="v.user_id">
                {{ v.real_name }}
                <span role="img" :aria-label="v.real_name" style="font-size: 14px; color: #888">
                  ({{ v.department.department_name }})
                </span>
              </a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item label="计调" prop="person_2">
            <a-select v-model="form.person_2" placeholder="请选择计调人员" :filter-option="filterOption" showSearch allowClear>
              <a-select-option v-for="v in userList" :key="v.user_id" :value="v.user_id">
                {{ v.real_name }}
                <span role="img" :aria-label="v.real_name" style="font-size: 14px; color: #888">
                  ({{ v.department.department_name }})
                </span>
              </a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item label="运营" prop="person_3">
            <a-select v-model="form.person_3" placeholder="请选择运营人员" :filter-option="filterOption" showSearch allowClear>
              <a-select-option v-for="v in userList" :key="v.user_id" :value="v.user_id">
                {{ v.real_name }}
                <span role="img" :aria-label="v.real_name" style="font-size: 14px; color: #888">
                  ({{ v.department.department_name }})
                </span>
              </a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item label="地域类型" prop="a_type">
            <a-select v-model="form.a_type" placeholder="请选择行程地域类型" allowClear>
              <a-select-option value="1">
                三亚
              </a-select-option>
              <a-select-option value="2">
                澳门
              </a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item label="订单时间" prop="trip_createtime">
            <a-date-picker style="width: 100%" :disabled-date="disabledDate" show-time placeholder="请选择订单创建时间!"
              v-model="form.trip_createtime" format="YYYY-MM-DD HH:mm:ss" value-format="YYYY-MM-DD HH:mm:ss" />
            <div style="line-height: 1.5;">PS: 订单创建时间，默认为当前时间，如果补录以前的行程，按照行程日期真实时间修改！！！</div>
          </a-form-model-item>
          <a-form-model-item label="小程序行程名称" prop="trip_appname">
            <a-input v-model="form.trip_appname" placeholder="小程序端显示的行程名称" rows="2" :maxLength="500"></a-input>
          </a-form-model-item>
          <a-form-model-item label="小程序行程备注" prop="trip_appremark">
            <a-textarea v-model="form.trip_appremark" placeholder="小程序端展示给客户的行程总备注" rows="2" :maxLength="500" />
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
  </a-modal>
</template>

<script>
import moment from 'moment'
export default {
  data() {
    return {
      visible: false,
      confirmLoading: false,
      times: [],
      form: {
        trip_id: "",
        customer_id: "",
        trip_name: "",
        trip_relationship: "",//人物关系
        trip_appremark: "",//小程序端展示给客户的行程备注
        person_length: "",
        trip_days: [],
        trip_msg: [],
        // trip_start: "",
        // trip_end: "",
        remind: "17:00:00",
        person_1: undefined, //销售
        person_2: undefined, //计调
        person_3: undefined, //运营
        a_type: undefined,//地域类型
        trip_createtime: "",
        trip_appname: ""//行程名称（小程序端显示）
      },
      treeData: [],
      groupList: [],
      loadingGroup: false,
      rules: {
        trip_name: [
          {
            required: true,
            message: "请输入行程名称",
            trigger: "blur",
          },
        ],
        person_length: {
          required: true,
          message: "请输入行程人数",
          trigger: "blur",
        },
        trip_days: {
          required: true,
          message: "请选择行程日期",
          trigger: "blur",
        },
        person_1: {
          required: true,
          message: "请选择销售人员",
          trigger: "blur",
        },
        person_2: {
          required: true,
          message: "请选择计调人员",
          trigger: "blur",
        },
        person_3: {
          required: true,
          message: "请选择运营人员",
          trigger: "blur",
        },
        a_type: {
          required: true,
          message: "请选择行程地域类型",
          trigger: "blur",
        },
        trip_createtime: {
          required: true,
          message: "请选择订单创建时间!",
          trigger: "blur",
        }
      },
      labelCol: { span: 6 },
      wrapperCol: { span: 17 },
      userList: []
    };
  },
  computed: {
    timelength() {
      if (!!this.form.trip_days && this.form.trip_days.length > 0) {
        // return this.form.trip_days.length
        return (new Date(this.times[1]) - new Date(this.times[0])) / 86400000 + 1
      } else {
        return 0;
      }
    },
  },
  methods: {
    init(trip_id, customer_id) {
      this.visible = true;
      this.form.trip_id = trip_id;
      this.form.customer_id = customer_id;
      this.getUserList()
      if (trip_id) {
        this.$http({
          url: "/admin/trip/info",
          method: "post",
          data: {
            id: trip_id,
          },
        }).then((res) => {
          this.form = {
            ...res.data,
            trip_days: res.data.trip_days.split(','),
            // trip_msg: res.data.trip_msg ? JSON.parse(res.data.trip_msg) : [],
            person_1: res.data.person_1 || undefined,
            person_2: res.data.person_2 || undefined,
            person_3: res.data.person_3 || undefined,
          };
          const dates = res.data.trip_days.split(',');
          this.times = [dates[0], dates[dates.length - 1]];
        });
      } else {
        this.form.trip_createtime = moment().format('YYYY-MM-DD HH:mm:ss')
      }
    },
    disabledDate(current) {
      // Can not select days before today and today
      return current && current > moment().endOf('day');
    },
    getUserList() {
      this.$http({
        url: "/admin/user/page?page=1&limit=200",
        method: "get",
      }).then((res) => {
        this.userList = res.data.result;
      });
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    del(index) {
      this.$confirm({
        title: '是否删除当前选择的行程',
        content: '删除后再做保存操作后，数据将不再恢复',
        onOk: () => {
          this.form.trip_msg.splice(index, 1)
        },
        onCancel() {
          console.log('Cancel');
        },
      });
    },
    handleOk() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.confirmLoading = true;
          this.$http({
            url: this.form.trip_id
              ? "/admin/trip/update"
              : "/admin/trip/create",
            method: "post",
            data: {
              ...this.form,
              trip_days: this.form.trip_days.join(","),
              // trip_msg: JSON.stringify(this.form.trip_msg)
            },
          })
            .then((res) => {
              this.$message.success(res.message);
              this.handleCancel();
              this.$emit("ok");
            })
            .finally(() => {
              this.confirmLoading = false;
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    getDatesBetween(startDateStr, endDateStr) {
      const startDate = new Date(startDateStr);
      const endDate = new Date(endDateStr);

      // 验证日期有效性
      if (isNaN(startDate.getTime()) || isNaN(endDate.getTime())) {
        throw new Error('Invalid date format');
      }

      // 确保开始日期不大于结束日期
      if (startDate > endDate) {
        return getDatesBetween(endDateStr, startDateStr);
      }

      const dates = [];
      let currentDate = new Date(startDate);

      while (currentDate <= endDate) {
        // 将日期格式化为 YYYY-MM-DD
        const dateStr = currentDate.toISOString().split('T')[0];
        dates.push(dateStr);

        // 增加一天
        currentDate.setDate(currentDate.getDate() + 1);
      }

      return dates;
    },
    changeDays(e) {
      console.log(e)
      if (!!e && e.length == 2) {
        this.form.trip_days = this.getDatesBetween(e[0], e[1])
      } else {
        this.form.trip_days = []
      }
      // console.log(e)
      // for (let i = 0; i < e.length; i++) {
      //   const index = this.form.trip_msg.findIndex(v => v.date == e[i])
      //   if (index == -1) {
      //     this.form.trip_msg.push({
      //       date: e[i],
      //       address: '',
      //       p_n: "",
      //       p_l: ""
      //     })
      //   }
      // }
      // this.form.trip_msg.sort((a, b) => new Date(a.date) - new Date(b.date))
    },
    handleCancel() {
      this.visible = false;
      this.times = [];
      this.confirmLoading = false;
      this.$refs["ruleForm"].resetFields();
    },
    //切换行程时间
    timesChange(e) {
      console.log(e);
      if (e.length == 2) {
        this.form.trip_start = e[0];
        this.form.trip_end = e[1];
      } else {
        this.form.trip_start = "";
        this.form.trip_end = "";
      }
    },
  },
};
</script>

<style></style>